module.exports = __webpack_public_path__ + "static/Service-staup-author2-860bcd61b431eff23d8adc56f6b35281.png";